










import {Component, Vue} from "vue-property-decorator";

@Component
export default class Introduction extends Vue {

    private configNamespace = 'config/';

    get heading(): string {
        return this.$store.getters[`${this.configNamespace}getIntroductionHeading`];
    }

    get text(): string{
        return this.$store.getters[`${this.configNamespace}getIntroductionText`];
    }

    get buttonText(): string {
        return this.$store.getters[`${this.configNamespace}getIntroductionButtonText`];
    }

    forward(): void{
        this.$router.push('search')
    }
}
